/*
  El menu estaba como una sola seccion 'TOOLS' con 25 entradas planas, en el orden
  en que se fueron construyendo las herramientas.

  La guia de contenido y experiencia de AdSense lo pide agrupado:

    "Add navigational elements to the menu bar and organize your content by topic,
     category, etc. This will help users to better understand and navigate your
     site."

  Y no es solo cumplir: 25 entradas sin jerarquia obligan a leer la lista entera
  para encontrar cualquier cosa, y no dan ninguna pista de que herramientas se usan
  juntas. Los grupos siguen el flujo real del juego —planificar, ejercito, equipo,
  investigacion, consulta— asi que las herramientas que se usan en la misma sesion
  quedan vecinas.

  Tambien se quito un hueco del array (habia un `,` suelto entre Troops y
  Artifacts, que dejaba un elemento vacio). No rompia nada porque Array.map salta
  los huecos de un array disperso, pero es una trampa para el proximo que agregue
  una entrada ahi.

  'Guides' reemplaza a 'Tips N Tricks'. Las 5 entradas que vivian en
  /tipsandtricks —el contenido escrito a mano con mas valor del sitio, que estaba
  detras de un acordeon y fuera del HTML— pasaron a ser articulos con su propia
  URL, autor, fecha y datos estructurados. Mantener las dos rutas seria servir el
  mismo texto en dos sitios, que es duplicado.
*/
const navigation = () => {
  return [
    {
      sectionTitle: 'START'
    },
    {
      title: 'Home',
      icon: 'mdi:home-outline',
      path: '/'
    },
    {
      title: 'Dashboard',
      icon: 'ic:round-dashboard',
      path: '/dashboard'
    },
    {
      sectionTitle: 'PLAN & BUILD'
    },
    {
      title: 'Planner',
      icon: 'arcticons:school-planner',
      path: '/planner'
    },
    {
      title: 'Buildings',
      icon: 'emojione-monotone:construction',
      path: '/building'
    },
    {
      title: 'Azurite',
      icon: 'game-icons:crystal-growth',
      path: '/azurite'
    },
    {
      title: 'Speeds',
      icon: 'material-symbols:speed-outline',
      path: '/speeds'
    },
    {
      sectionTitle: 'ARMY'
    },
    {
      title: 'Troops',
      icon: 'game-icons:rally-the-troops',
      path: '/troops'
    },
    {
      title: 'Beast',
      icon: 'game-icons:beast-eye',
      path: '/beast'
    },
    {
      title: 'Colossus',
      icon: 'game-icons:giant',
      path: '/colossus'
    },
    {
      title: 'Totems',
      icon: 'game-icons:totem',
      path: '/totem'
    },
    {
      sectionTitle: 'GEAR'
    },
    {
      title: 'Artifacts',
      icon: 'game-icons:glowing-artifact',
      path: '/artifacts'
    },
    {
      title: 'Equipment',
      icon: 'game-icons:shoulder-armor',
      path: '/equipment'
    },
    {
      title: 'Jewels',
      icon: 'game-icons:diamond-hard',
      path: '/jewels',
      badgeContent: 'New'
    },
    {
      sectionTitle: 'RESEARCH'
    },
    {
      title: 'Mystic',
      icon: 'basil:university-outline',
      path: '/mystic'
    },
    {
      title: 'High College',
      icon: 'la:school',
      path: '/college'
    },
    {
      sectionTitle: 'REFERENCE'
    },
    {
      title: 'Database',
      icon: 'carbon:data-volume',
      path: '/database'
    },
    {
      title: 'Realms',
      icon: 'bi:globe',
      path: '/realms'
    },
    {
      title: 'Packs',
      icon: 'emojione-monotone:money-with-wings',
      path: '/packs'
    },
    {
      title: 'Garden',
      icon: 'game-icons:flower-pot',
      path: '/garden',
      badgeContent: 'New'
    },
    {
      title: 'Shields',
      icon: 'material-symbols:security',
      path: '/shields',
      badgeContent: 'New'
    },
    {
      title: 'Minitools',
      icon: 'et:tools-2',
      path: '/minitools'
    },
    {
      sectionTitle: 'LEARN'
    },
    {
      title: 'Guides',
      icon: 'mdi:book-open-page-variant-outline',
      path: '/guides'
    },
    {
      sectionTitle: 'ABOUT THIS SITE'
    },
    {
      title: 'Contributors',
      icon: 'mdi:help-outline',
      path: '/contributors'
    },
    {
      title: 'Release Notes',
      icon: 'material-symbols:new-releases',
      path: '/releases'
    }
  ]
}

export default navigation
